import { render, staticRenderFns } from "./sustainabilityDatatable.vue?vue&type=template&id=a8453122&"
import script from "./sustainabilityDatatable.vue?vue&type=script&lang=js&"
export * from "./sustainabilityDatatable.vue?vue&type=script&lang=js&"
import style0 from "./sustainabilityDatatable.vue?vue&type=style&index=0&id=a8453122&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTable,QTr,QTh,QTd});
